import React from 'react';


export class FormGroup extends React.Component {
    render() {
        const {
            id = Math.floor(100000 + Math.random() * 900000),
            color = 'main',
            value = '',
            label = null,
            prefix = null,
            suffix = null,
            placeholder = '',
            type = 'text',
            dataAttribute = null,
            onChange = (event) => {},
            onKeyDown = (event) => {},
            buttonText = null,
            buttonOnClick = (event) => {}
        } = this.props;
        
        return (
            <div className={'imd-form-group imd-border-bottom-color-' + color}>
                <input
                    id={'imd-form-group-id-' + id}
                    className={'imd-text-' + color}
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    data-attribute={dataAttribute}
                    onChange={(event) => onChange(event)}
                    onKeyDown={(event) => onKeyDown(event)}
                />

                {
                    prefix !== null ?
                        <label className={'imd-form-control-prefix imd-text-120-' + color}>{prefix}</label> :
                        null
                }

                {
                    label !== null ?
                        <label className={'imd-description imd-text-120-' + color} htmlFor={'imd-form-group-id-' + id}>{label}</label> :
                        null
                }

                {
                    buttonText !== null ?
                        <button className={'imd-text-real-white imd-bg-gradient-reverse-' + color} onClick={() => buttonOnClick()}>
                            {buttonText}
                        </button> :
                        null
                }

                {
                    suffix !== null ?
                        <label className={'imd-form-control-suffix imd-text-120-' + color}>{suffix}</label> :
                        null
                }

                <div className={'imd-decorator imd-bg-' + color} />
            </div>
        );
    }
}
